import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4fb8d149")

_pushScopeId("data-v-4fb8d149")
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-row gap-3 overflow-hidden" }
const _hoisted_3 = {
  class: "sticky top-0 left-0 pl-2 pb-6 flex flex-col gap-y-4",
  style: {"max-width":"364px"}
}
const _hoisted_4 = {
  class: "flex flex-col gap-3 overflow-auto max-h-screen h-full",
  style: {"flex":"2","padding-bottom":"200px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InfoDetailClient = _resolveComponent("InfoDetailClient")!
  const _component_ClientRateHistory = _resolveComponent("ClientRateHistory")!
  const _component_ConfirmationApprovalRejectClient = _resolveComponent("ConfirmationApprovalRejectClient")!
  const _component_InfoPriceClient = _resolveComponent("InfoPriceClient")!
  const _component_ClientDetailCardParent = _resolveComponent("ClientDetailCardParent")!
  const _component_ClientDetailCardBranch = _resolveComponent("ClientDetailCardBranch")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetail,
      title: _ctx.title,
      fullPage: "",
      verticalSeparator: false
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_InfoDetailClient, {
              clientName: _ctx.detailData.clientName,
              clientStatus: _ctx.detailData.clientStatus,
              createdAt: _ctx.createdAt,
              createdBy: _ctx.detailData.clientCreatedBy,
              updatedAt: _ctx.updatedAt,
              updatedBy: _ctx.detailData.clientUpdatedBy,
              isClientParent: _ctx.isParent,
              showBalance: false,
              clientFreeze: _ctx.detailData.clientFreeze,
              rateUpdatedAt: _ctx.detailData.rateUpdatedAt,
              rateUpdatedBy: _ctx.detailData.rateUpdatedBy,
              detailUpdatedBy: _ctx.detailData.newestUpdatedDetail.updatedByName,
              detailUpdatedAt: _ctx.detailData.newestUpdatedDetail.updatedAt,
              freezeReason: _ctx.detailData.clientBannedReason,
              freezeUpdatedAt: _ctx.updatedAt,
              freezeUpdatedBy: _ctx.detailData.clientUpdatedBy
            }, null, 8, ["clientName", "clientStatus", "createdAt", "createdBy", "updatedAt", "updatedBy", "isClientParent", "clientFreeze", "rateUpdatedAt", "rateUpdatedBy", "detailUpdatedBy", "detailUpdatedAt", "freezeReason", "freezeUpdatedAt", "freezeUpdatedBy"]),
            (_ctx.showClientRateHistory)
              ? (_openBlock(), _createBlock(_component_ClientRateHistory, {
                  key: 0,
                  detailData: _ctx.detailData
                }, null, 8, ["detailData"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_4, [
            (_ctx.isRequested && _ctx.isApprovalEnable)
              ? (_openBlock(), _createBlock(_component_ConfirmationApprovalRejectClient, {
                  key: 0,
                  clientType: _ctx.isParent ? _ctx.$t('clientManagement.managementList.parentClient').toString().toLowerCase() : _ctx.$t('clientManagement.managementList.branchClient').toString().toLowerCase(),
                  id: _ctx.detailData.id,
                  clientName: _ctx.detailData.clientName,
                  onSuccessReject: _ctx.fetchDetail
                }, null, 8, ["clientType", "id", "clientName", "onSuccessReject"]))
              : _createCommentVNode("", true),
            (_ctx.isParent)
              ? (_openBlock(), _createBlock(_component_InfoPriceClient, {
                  key: 1,
                  detailData: _ctx.detailData,
                  onCancelUploadRate: _ctx.fetchDetail
                }, null, 8, ["detailData", "onCancelUploadRate"]))
              : _createCommentVNode("", true),
            (_ctx.isParent)
              ? (_openBlock(), _createBlock(_component_ClientDetailCardParent, {
                  key: 2,
                  detailData: _ctx.detailData,
                  title: _ctx.$t('clientManagement.managementDetail.parentDetailTitle')
                }, null, 8, ["detailData", "title"]))
              : (_openBlock(), _createBlock(_component_ClientDetailCardBranch, {
                  key: 3,
                  title: _ctx.$t('clientManagement.managementDetail.branchDetailTitle')
                }, null, 8, ["title"]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"])
  ]))
})